<p-accordion-panel [value]="index()">
  <p-accordion-header>
    <div class="me-4 flex flex-1 items-center justify-between gap-4">
      <div class="flex items-center gap-2 text-sm text-gray-400">
        <span>{{ panelCount() }}</span>
        <span>{{ currentName$ | async | noData }}</span>
      </div>

      <div>
        @if (shouldRemove()) {
          <p-button
            (onClick)="handleProductRemoveClick()"
            severity="danger"
            label="Usuń"
            appPrimengButton />
        }
      </div>
    </div>
  </p-accordion-header>

  <p-accordion-content>
    <app-form-control label="Właściciel">
      <p-select
        [formControl]="productFormGroup().controls.ownerId"
        [options]="valueOrDefault(ownerSelectItems$ | async, [])"
        appPrimengSelect
        [fluid]="true"
        placeholder="Wybierz właściciela" />
    </app-form-control>

    <app-form-control label="Nazwa">
      <input
        [formControl]="productFormGroup().controls.name"
        pInputText
        placeholder="Wprowadź nazwę" />
    </app-form-control>

    <app-form-control label="Marka kosmetyczna">
      <p-auto-complete
        (completeMethod)="handleCompleteMethod($event)"
        [dropdown]="true"
        [formControl]="productFormGroup().controls.brand"
        [suggestions]="valueOrDefault(brandSuggestionSelectItems, [])"
        [fluid]="true"
        placeholder="Wprowadź lub wybierz markę" />
    </app-form-control>

    <app-form-control
      inputId="c4a0c8e3-878b-458d-9a4e-5f2ebebb8de3"
      label="Promocja">
      <app-checkbox-with-label
        inputId="c4a0c8e3-878b-458d-9a4e-5f2ebebb8de3"
        type="short">
        <p-checkbox
          [binary]="true"
          [formControl]="productFormGroup().controls.promotion" />

        <span label>Produkt promocyjny</span>
      </app-checkbox-with-label>
    </app-form-control>

    <app-form-control label="Rodzaj">
      <p-select
        [formControl]="productFormGroup().controls.type"
        [options]="valueOrDefault(productTypeSelectItems$ | async, [])"
        appPrimengSelect
        [fluid]="true"
        placeholder="Wybierz rodzaj" />
    </app-form-control>

    <div class="grid grid-cols-2 gap-4">
      <app-form-control label="Numer artykułu (SKU)">
        <input
          [formControl]="productFormGroup().controls.sku"
          pInputText
          placeholder="Wprowadź numer artykułu" />

        <app-warehouse-sku-usage-status [sku]="currentSku$ | async" />
      </app-form-control>

      <app-form-control label="Numer partii">
        <input
          [formControl]="productFormGroup().controls.batchNumber"
          pInputText
          placeholder="Wprowadź numer partii" />
      </app-form-control>
    </div>

    <div class="grid grid-cols-2 gap-4">
      <app-form-control label="Ilość">
        <input
          [formControl]="productFormGroup().controls.quantity"
          pInputText
          placeholder="Wprowadź ilość"
          type="number" />
      </app-form-control>

      <app-form-control label="Jednostka miary">
        <p-select
          [formControl]="productFormGroup().controls.unit"
          [options]="valueOrDefault(unitSelectItems$ | async, [])"
          appPrimengSelect
          [fluid]="true"
          placeholder="Wybierz jednostkę miary" />
      </app-form-control>
    </div>

    <div class="grid grid-cols-2 gap-4">
      <app-form-control
        hint="Przykład: 30 dni od otwarcia, 60 dni od daty produkcji."
        label="Okres przydatności">
        <input
          [formControl]="productFormGroup().controls.durabilityInformation"
          pInputText
          placeholder="Wprowadź okres przydatności" />
      </app-form-control>
    </div>
  </p-accordion-content>
</p-accordion-panel>
